import "./LessonReportStarDisplay.css";

type Props = {
  value: number | null;
  max?: number;
  showValue?: boolean;
  className?: string;
};

export default function LessonReportStarDisplay({
  value,
  max = 5,
  showValue = true,
  className,
}: Props) {
  if (value === null || value === undefined || Number.isNaN(value)) {
    return <span className="lr-stars lr-stars--empty">—</span>;
  }

  const rounded = Math.round(value * 10) / 10;
  const fullStars = Math.floor(value + 0.25);
  const hasHalf = value - fullStars >= 0.25 && fullStars < max;

  const rootClass = ["lr-stars", className].filter(Boolean).join(" ");

  return (
    <div className={rootClass} title={`${rounded}/${max}`}>
      <span className="lr-stars__row" aria-hidden>
        {Array.from({ length: max }, (_, i) => {
          const star = i + 1;
          let cls = "lr-stars__star";
          if (star <= fullStars) cls += " is-on";
          else if (hasHalf && star === fullStars + 1) cls += " is-half";
          return (
            <span key={star} className={cls}>
              ★
            </span>
          );
        })}
      </span>
      {showValue && <span className="lr-stars__value">{rounded}</span>}
    </div>
  );
}
